import moment from 'moment';

// return true if at least one item in array b can be found in arrary a
export const containAtLeastOneItems = (a: any[], b: any[]): boolean => {
  for (const str of b) {
    if (a.includes(str)) {
      return true;
    }
  }

  return false;
};

// return true if every item in array b can be found in array a
export const containAllItems = (a: any[], b: any[]): boolean => {
  for (const str of b) {
    if (!a.includes(str)) {
      return false;
    }
  }

  return true;
};

// COMPARISON HELPER FUNCTIONS FOR SORTING
// consider using the line below before evoking for clarity on the defaultSort
// const [asc, desc, newest, oldest] = [true, false, true, false]
// ex: compareAlphanums = (a, b, desc)

// defaultSort is ascending
export const compareAlphanums = (a: any, b: any, defaultSort = true) => {
  if (defaultSort) {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  } else {
    if (a > b) {
      return -1;
    }
    if (a < b) {
      return 1;
    }
    return 0;
  }
};

// defaultSort is newest
export const compareDates = (a: Date, b: Date, defaultSort = true) => {
  if (defaultSort) {
    if (moment(a).isBefore(b)) {
      return 1;
    }
    if (moment(a).isAfter(b)) {
      return -1;
    }
    return 0;
  } else {
    if (moment(a).isAfter(b)) {
      return 1;
    }
    if (moment(a).isBefore(b)) {
      return -1;
    }
    return 0;
  }
};

export const convertLargeNumbersToRoundedString = (num: number, decimalPlaces = 1): string => {
  let value = '';
  if (num >= 1000000000) {
    // Represent in Billions when Impressions are above and equal to 1B
    value = (num / 1000000000).toFixed(decimalPlaces).toString() + 'B';
  } else if (num >= 1000000) {
    // Represent in Millions when Impressions are above and equal to 1M
    value = (num / 1000000).toFixed(decimalPlaces).toString() + 'M';
  } else if (num >= 1000) {
    value = (num / 1000).toFixed(decimalPlaces).toString() + 'k';
  } else {
    value = `${num}`;
  }
  return value;
};

// Takes a string rep of an integer or float and returns version with commas
// ex. addCommasToIntegerOrFloat("1234567.89") -> "1,234,567.89"
// ex. addCommasToIntegerOrFloat("123") -> "123"
export const addCommasToIntegerOrFloat = (value: string): string => {
  if (value === undefined) {
    value = '';
  }
  const intValue = value.split('.')[0];
  const commaDelimDigits: string[] = [];
  for (let i = 0; i < intValue.length; i++) {
    if (i % 3 === intValue.length % 3 && i > 0) {
      commaDelimDigits.push(',');
    }
    commaDelimDigits.push(intValue[i]);
  }
  if (value.split('.').length === 2) {
    commaDelimDigits.push('.');
    commaDelimDigits.push(value.split('.')[1]);
  }
  return commaDelimDigits.join('');
};
